import React, { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/Layout/DashboardLayout";
import { LayoutDashboard, Package, DollarSign } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";
import { useCurrency } from "@/contexts/CurrencyContext";

const items = (t) => [
  { to: "/rider", icon: LayoutDashboard, label: t("dashboard"), end: true, tid: "rider-nav-dashboard" },
  { to: "/rider/jobs", icon: Package, label: t("availableJobs"), tid: "rider-nav-jobs" },
  { to: "/rider/earnings", icon: DollarSign, label: t("earnings"), tid: "rider-nav-earnings" },
];

export default function RiderEarnings() {
  const { t } = useLang();
  const { formatPrice } = useCurrency();
  const [earn, setEarn] = useState({ total_earnings: 0, deliveries_completed: 0 });
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/rider/earnings").then(r => setEarn(r.data));
    api.get("/orders/mine").then(r => setOrders(r.data.filter(o => o.status === "delivered")));
  }, []);

  return (
    <DashboardLayout items={items(t)} title={t("earnings")}>
      <div className="grid sm:grid-cols-2 gap-4 mb-6">
        <div className="rounded-3xl p-6 text-white so-gradient-hero">
          <div className="text-xs uppercase tracking-widest text-white/60">Total earnings</div>
          <div className="text-4xl font-extrabold mt-1" data-testid="total-earnings">{formatPrice(earn.total_earnings)}</div>
        </div>
        <div className="so-card p-6">
          <div className="text-xs uppercase tracking-widest text-[var(--so-text-soft)]">Total deliveries</div>
          <div className="text-4xl font-extrabold mt-1" data-testid="total-deliveries">{earn.deliveries_completed}</div>
        </div>
      </div>
      <h2 className="font-bold mb-3">Recent deliveries</h2>
      <div className="space-y-2">
        {orders.length === 0 && <div className="text-sm text-[var(--so-text-soft)]">No completed deliveries yet.</div>}
        {orders.map(o => (
          <div key={o.id} className="so-card p-3 flex items-center gap-3" data-testid={`done-${o.id}`}>
            <div className="flex-1 min-w-0">
              <div className="font-semibold">{o.restaurant_name} → {o.customer_name}</div>
              <div className="text-xs text-[var(--so-text-soft)]">{new Date(o.created_at).toLocaleString()}</div>
            </div>
            <div className="font-bold text-[var(--so-orange)]">+{formatPrice(o.delivery_fee)}</div>
          </div>
        ))}
      </div>
    </DashboardLayout>
  );
}
